export default __webpack_public_path__ + "static/media/mud-icon.f5197f48.svg";